import styled from 'styled-components'

export const ContainerGeral = styled.section`
  float: left;
  width: 100%;
  padding: 150px 50px;
  background: #0A121F;
  position: relative;

  @media only screen and (max-width: 768px) {
    padding: 30px;
  }

`

// Box Fechar 
export const BoxFechar = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`

// Imagem Botão
export const ImagemBotao = styled.img``
